
import { Component, Vue } from 'vue-property-decorator'
import BgComp from '../components/bgComp.vue'
import { Getter } from 'vuex-class'
import { getGuaranteeBrushFace } from '@/api/guarantee'
import { getBHCreditReport } from '@/api/approve'
@Component({
  components: {
    BgComp
  }
})
export default class faceResult extends Vue {
  @Getter companyId: string // 公司编号
  @Getter companyName: string // 公司名称
  currentRate = 20
  timeId = null
  isPass = false
  unifiedSocialCreditCode = ''

  created() {
    this.changeNativeAreaColor(true)
    console.log('flag', this.$route.query.flag)

    this.timeId = setInterval(() => {
      this.currentRate += 20
      if (this.currentRate === 80) {
        clearInterval(this.timeId)
      }
    }, 1000)
    this.getGuaranteeBrushFace()
  }
  handleBack() {
    // this.$router.back()
    // ios返回会直接返回到人脸识别页面，处理这种情况
    this.$router.go(-2)
  }
  // 点击确认按钮
  handleBtn() {
    if (this.isPass) {
      this.getBHCreditReport()
    } else {
      // this.$router.replace({
      //   name: 'FaceConfirm',
      //   query: JSON.parse(window.localStorage.getItem('approve'))
      // })
      // this.$router.back()
      this.$router.go(-2)
    }
  }
  // 是否企业认证 2为身份认证 ，1为企业认证
  isCompany() {
    let data = JSON.parse(window.localStorage.getItem('approve'))
    console.log('data', data)

    return data.flag ? 2 : 1
  }
  // 获取刷脸结果
  getGuaranteeBrushFace() {
    let { companyId, orderNo } = JSON.parse(
      window.localStorage.getItem('approve')
    )
    getGuaranteeBrushFace({
      companyId,
      orderNo
    })
      .then((res) => {
        console.log('getGuaranteeBrushFace', res)
        if (res.code === '000000') {
          this.isPass = true
          this.getBHCreditReport()
        } else if (res.code === '000002') {
          this.isPass = false
          this.$dialog
            .alert({
              title: '查询结果',
              message: res.msg
            })
            .then(() => {
              this.$router.go(-2)
            })
        }
      })
      .catch(() => {
        this.isPass = false
      })
      .finally(() => {
        this.currentRate = 100
      })
  }
  // 获取百行征信
  getBHCreditReport() {
    let { unifiedSocialCreditCode, orderNo } = JSON.parse(
      window.localStorage.getItem('approve')
    )
    let data = {
      orderNo,
      companyId: this.companyId,
      companyName: this.companyName,
      unifiedSocialCreditCode: unifiedSocialCreditCode,
      identificationType: this.isCompany()
    }
    getBHCreditReport(data)
      .then((res) => {
        console.log('getBHCreditReport', res)
        //   this.$toast(res.msg)
        if (res.code === '000000') {
          this.$router.push({
            name: 'ApproveFinish',
            query: {
              flag: this.isCompany() + '',
              userOtherType: res.data.userOtherType,
              msg: res.msg
            }
          })
        } else {
          this.$dialog
            .alert({
              title: '查询结果',
              message: res.msg
            })
            .then(() => {
              // on confirm
              // if (this.isCompany() === 1) {
              //   this.$router.replace({
              //     name: 'CompanyInfoForm'
              //   })
              // } else {
              //   this.$router.replace({
              //     name: 'UserInfoForm'
              //   })
              // }
              this.$router.go(-2)
            })
        }
      })
      .catch((res) => {
        console.log('catch', res)
      })
  }

  destroyed() {
    this.changeNativeAreaColor(false)
  }

  changeNativeAreaColor (isCreated: boolean) {
    const params = {
      statusBarColor: 'FFFFFF',  // 状态栏颜色
      bottomColor: isCreated ? 'F3F3F3' : 'FFFFFF', // 底部安全区颜色
      alpha: 1
    }
    this.$bridge.callHandler('changeNativeAreaColor', params, (res) => {
    })
  }
}
